import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "9" } },
            [
              _c("AtTextField", {
                attrs: {
                  type: "number",
                  placeholder: "0.00",
                  label: _vm.$t("components.TTCPriceField.price"),
                  hint:
                    "1 " +
                    _vm.selectedCurrencyCode +
                    " ≈ " +
                    parseInt(1 / _vm.unitPrice) +
                    " " +
                    _vm.$t("components.TTCPriceField.coins"),
                  rules: _vm.priceRules,
                  "persistent-hint": "",
                  disabled: true,
                },
                model: {
                  value: _vm._price,
                  callback: function ($$v) {
                    _vm._price = _vm._n($$v)
                  },
                  expression: "_price",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            VCol,
            { attrs: { cols: "3" } },
            [
              _c(VSelect, {
                attrs: {
                  outlined: "",
                  items: _vm.coinACurrencyList,
                  "item-text": "code",
                  "item-value": "code",
                },
                model: {
                  value: _vm.selectedCurrencyCode,
                  callback: function ($$v) {
                    _vm.selectedCurrencyCode = $$v
                  },
                  expression: "selectedCurrencyCode",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        VRow,
        [
          _c(
            VCol,
            {
              staticStyle: { padding: "0", margin: "-24px 0" },
              attrs: { align: "center" },
            },
            [_c(VIcon, [_vm._v("mdi-swap-vertical")])],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        VRow,
        [
          _c(
            VCol,
            [
              _c("AtTextField", {
                attrs: {
                  type: "number",
                  placeholder: "0",
                  label: "",
                  suffix: _vm.$t("components.TTCPriceField.coinLabel"),
                  hint:
                    "1 " +
                    _vm.$t("components.TTCPriceField.coin") +
                    " ≈ " +
                    parseFloat(_vm.unitPrice) +
                    " " +
                    _vm.selectedCurrencyCode,
                  rules: _vm.coinsRules,
                  "persistent-hint": "",
                },
                model: {
                  value: _vm._coins,
                  callback: function ($$v) {
                    _vm._coins = _vm._n($$v)
                  },
                  expression: "_coins",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        VRow,
        [
          _c(
            VCol,
            [
              _c("AtTextField", {
                attrs: {
                  disabled: true,
                  type: "number",
                  placeholder: "0",
                  label: "",
                  suffix: _vm.$t("components.TTCPriceField.tokenLabel"),
                },
                model: {
                  value: _vm.rebate,
                  callback: function ($$v) {
                    _vm.rebate = _vm._n($$v)
                  },
                  expression: "rebate",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.topUpMode
        ? _c(
            VRow,
            [
              _c(
                VCol,
                [
                  _c("label", [
                    _vm._v(
                      _vm._s(_vm.$t("components.TTCPriceField.percentage"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c(VSlider, {
                    staticClass: "mt-10",
                    attrs: {
                      "thumb-label": "always",
                      min: _vm.minTokenPercentage,
                      max: _vm.maxTokenPercentage,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "prepend",
                          fn: function () {
                            return [
                              _c(
                                VTooltip,
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              VIcon,
                                              _vm._g(
                                                _vm._b(
                                                  {},
                                                  "v-icon",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  "\n                mdi-help-circle-outline\n              "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1242852305
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "components.TTCPriceField.percentageHint",
                                            {
                                              min: _vm.minTokenPercentage,
                                              max: _vm.maxTokenPercentage,
                                            }
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "thumb-label",
                          fn: function ({ value }) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(value + "%") +
                                  "\n        "
                              ),
                            ]
                          },
                        },
                        {
                          key: "append",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex align-center",
                                  staticStyle: { width: "120px" },
                                },
                                [
                                  _c("AtTextField", {
                                    staticClass: "mt-0 pt-0",
                                    staticStyle: { width: "32px" },
                                    attrs: {
                                      type: "number",
                                      placeholder: "0",
                                      label: "",
                                      "hide-details": "",
                                      "single-line": "",
                                      outlined: false,
                                    },
                                    on: {
                                      blur: () => {
                                        if (_vm.percentageWarningMessage)
                                          _vm.$dialog.notify.warning(
                                            _vm.percentageWarningMessage
                                          )
                                      },
                                    },
                                    model: {
                                      value: _vm._tokens,
                                      callback: function ($$v) {
                                        _vm._tokens = _vm._n($$v)
                                      },
                                      expression: "_tokens",
                                    },
                                  }),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t(
                                          "components.TTCPriceField.tokenLabel"
                                        )
                                      ) +
                                      "\n          "
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3676305864
                    ),
                    model: {
                      value: _vm.percentage,
                      callback: function ($$v) {
                        _vm.percentage = _vm._n($$v)
                      },
                      expression: "percentage",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    { staticClass: "text-caption", attrs: { to: "404" } },
                    [
                      _c("u", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "components.TTCPriceField.percentageLearnMore"
                            )
                          )
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }